
import { Button } from "@/components/ui/button";
import { FileIcon, FilesIcon } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { exportToCSV, exportToExcel } from "../../utils/exportData";
import { NewsletterSubscriber } from "../../utils/types";

interface ExportButtonsProps {
  subscribers: NewsletterSubscriber[];
}

export const ExportButtons = ({ subscribers }: ExportButtonsProps) => {
  const formatSubscribersForExport = (subscribers: NewsletterSubscriber[]) => {
    return subscribers.map(subscriber => ({
      Prénom: subscriber.first_name,
      Nom: subscriber.last_name,
      Email: subscriber.email,
      Statut: subscriber.is_active ? "Actif" : "Inactif",
      "Date de vérification": subscriber.verified_at ? new Date(subscriber.verified_at).toLocaleDateString('fr-FR') : 'Non vérifié',
      "Date d'inscription": new Date(subscriber.created_at).toLocaleDateString('fr-FR')
    }));
  };

  const handleExportToExcel = () => {
    if (subscribers.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des abonnés est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatSubscribersForExport(subscribers);
      exportToExcel(formattedData, `abonnes_newsletter_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier Excel a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers Excel.",
        variant: "destructive",
      });
    }
  };
  
  const handleExportToCSV = () => {
    if (subscribers.length === 0) {
      toast({
        title: "Aucune donnée à exporter",
        description: "La liste des abonnés est vide.",
        variant: "destructive",
      });
      return;
    }
    
    try {
      const formattedData = formatSubscribersForExport(subscribers);
      exportToCSV(formattedData, `abonnes_newsletter_export_${new Date().toISOString().split('T')[0]}`);
      toast({
        title: "Export réussi",
        description: "Le fichier CSV a été téléchargé.",
      });
    } catch (error) {
      toast({
        title: "Erreur lors de l'export",
        description: "Impossible d'exporter les données vers CSV.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Button 
        onClick={handleExportToExcel}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={subscribers.length === 0}
      >
        <FileIcon size={18} />
        Excel
      </Button>
      <Button 
        onClick={handleExportToCSV}
        variant="outline" 
        className="flex items-center gap-2"
        disabled={subscribers.length === 0}
      >
        <FilesIcon size={18} />
        CSV
      </Button>
    </div>
  );
};
